<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="dialogVisible"
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`${tipAdd()}项目类别`"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction">
            <el-form class="publish-form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="name" label="类别名称">
                    <el-input v-model="ruleForm.name" placeholder="请输入">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button  @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import {tipAdd} from "@/utils/utils";
    import {saveProjectCate} from "@/api";

    export default {
        name: "AddClassifyDialog",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            uid: { //单位ID
                type: Number,
            },
            name: {
                type: String,
            },
        },
        data() {
            return {
                id:0,
                loading: false,
                ruleForm: {
                    name: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入类别名称', trigger: 'blur'}
                    ],
                },
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
               this.ruleForm.name = this.name
            },
            tipAdd(){
                return tipAdd(this.id,'添加')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addItem();
                    }
                });
            },
            async addItem() {
                this.loading = true
                let _data = await saveProjectCate(this.uid,this.ruleForm.name)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState', true)
                }
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
        },
        watch: {
            name() {
                this.init()
            }
        }
    }
</script>

<style scoped lang="scss">

</style>